export default {
      id: "max-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "app/svg/sprite.svg#max",
      toString: function () {
        return this.url;
      }
    }